<script lang="ts">
    import { Router, Route } from "svelte-navigator";
    import Home from "./pages/Home.svelte";
    import Result from "./pages/Result.svelte";

</script>
<main>
<Router primary={false}>
    <Route path="/">
        <Home/>
    </Route>
    <Route path="/result">
        <Result />
    </Route>
</Router>
</main>